import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const awards = () => {

	let els = document.querySelectorAll('[data-animation="awards"]')

	if (!els.length) return false

	els.forEach(el => {

		let track = el.querySelector('[data-el="track"]')

		let marquee = gsap.fromTo(track, {
			xPercent: -50,
		}, {
			xPercent: -150,
			duration: 20,
			repeat: -1,
			ease: 'linear',
		})

		if (window.innerWidth > 960) {

			marquee.progress(30)

			ScrollTrigger.create({
				trigger: el,
				start: "top bottom",
				end: "bottom top",
				// markers: true,
				onUpdate: (self) => {
					let velocity = self.getVelocity()
					if (velocity < 0) marquee.timeScale((velocity / 100) - 1)
					if (velocity >= 0) marquee.timeScale((velocity / 100) + 1)
				}
			})

		}

	})
}

export default () => { }